import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/term_icfes_experience_validation/`, data);
};

const get = async (id) => {
  return await httpClient.get(`/term_icfes_experience_validation/${id}`);
};

const getAllByValidation = async (validation_id, tipo_persona) => {
  return await httpClient.get(
    `/term_icfes_experience_validation/documents/?filter[document_validation]=${validation_id}&filter[tipo_persona]=${tipo_persona}`,
  );
};

const put = async (id, data) => {
  return await httpClient.put(`/term_icfes_experience_validation/${id}/`, data);
};

const patch = async (id, data) => {
  return await httpClient.patch(
    `/term_icfes_experience_validation/${id}/`,
    data,
  );
};

const remove = async (id) => {
  return await httpClient.delete(`/term_icfes_experience_validation/${id}`);
};

export { post, get, getAllByValidation, put, patch, remove };
